// One centered reading column for the transcript, composer, and the
// chrome that sits with them. Gutters grow outside this width.
export const CHAT_COLUMN_CLASS = 'mx-auto w-full max-w-[720px] min-w-0 px-5';
